import type { StockStatus } from "@/api/types";

const LABELS: Record<StockStatus, string> = {
  in_stock: "在庫あり",
  low_stock: "残りわずか",
  out_of_stock: "在庫切れ",
};

const CLASSES: Record<StockStatus, string> = {
  in_stock: "badge-green",
  low_stock: "badge-yellow",
  out_of_stock: "badge-red",
};

export function StockBadge({ status, count }: { status: StockStatus; count?: number }) {
  return (
    <span className={CLASSES[status]}>
      {LABELS[status]}
      {typeof count === "number" && count > 0 ? ` (${count})` : null}
    </span>
  );
}
